<template>
  <!-- Add -->
  <div
    class="modal fade"
    id="add_item"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ isEditMode ? "Update" : "Create" }} {{ title }}
          </h5>
          <div class="d-flex align-items-center">
            <button
              class="btn-close custom-btn-close border p-1 me-0 text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <!-- Input Fields -->
            <div class="mb-3">
              <label class="col-form-label"
                >Name <span class="text-danger">*</span></label
              >
              <input type="text" class="form-control" v-model="name" />
              <div class="text-danger" v-if="errors.name">
                {{ errors.name[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label"
                >Select Country <span class="text-danger">*</span></label
              >
              <multiselect
                v-model="countryID"
                :options="countries"
                track-by="id"
                label="name"
                placeholder="Select Country"
              >
              </multiselect>
              <div class="text-danger" v-if="errors.country_id">
                {{ errors.country_id[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label"
                >Select Division <span class="text-danger">*</span></label
              >
              <multiselect
                v-model="divisionID"
                :options="divisions"
                track-by="id"
                label="name"
                placeholder="Select Division"
              >
              </multiselect>
              <div class="text-danger" v-if="errors.division_id">
                {{ errors.division_id[0] }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex align-items-center justify-content-end m-0">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                {{ isEditMode ? "Update" : "Create" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add  -->

  <!-- Delete -->
  <div class="modal fade" id="delete_item" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <div class="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i class="ti ti-trash-x fs-36 text-danger"></i>
            </div>
            <h4 class="mb-2">Remove {{ title }}?</h4>
            <p class="mb-0">Are you sure you want to remove it</p>
            <div class="d-flex align-items-center justify-content-center mt-4">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                class="btn btn-danger"
                @click="deleteItem()"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                Yes, Delete it
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete -->
</template>
<script>
import http from "@/utils/http";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    isLoading: false,
    name: "",
    countries: [],
    countryID: "",
    allDivisions: [],
    divisions: [],
    divisionID: "",
    itemId: null,
    errors: {},
  }),

  watch: {
    countryID(newValue) {
      if (newValue) {
        this.getDivisionsByCountry();
      }
    },
  },

  mounted() {
    this.$emitter.on("add-edit-item", (row) => {
      this.getCountries();
      if (row) {
        this.itemId = row.id;
        this.name = row.name;
        this.countryID = row.country_id;
        this.divisionID = row.division_id;
      }
      this.$handleModal("add_item", "toggle");
    });

    this.$emitter.on("delete-item-modal", (row) => {
      if (row) {
        this.itemId = row.id;
      }
      this.$handleModal("delete_item", "toggle");
    });
  },

  methods: {
    async getCountries() {
      try {
        const response = await http.get("countries");
        this.countries = response.data.contents;
        if (this.countryID != "") {
          const foundCountry = response.data.contents.find(
            (data) => data.id == this.countryID
          );
          if (foundCountry) {
            this.countryID = foundCountry;
          }
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    async getDivisions() {
      try {
        const response = await http.get("divisions");
        this.allDivisions = response.data.contents;
      } catch (error) {
        console.error("Error:", error);
      }
    },

    async getDivisionsByCountry() {
      this.divisions = [];
      const endpoint = `/divisions-by-country`;
      const method = "post";
      let body = {
        country_id: this.countryID.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.divisions = response.data.contents;

        if (this.divisionID != "") {
          const foundDivision = this.divisions.find(
            (data) => data.id == this.divisionID
          );
          if (foundDivision) {
            this.divisionID = foundDivision;
          }
        }
      } catch (error) {
        //
      }
    },

    async submitForm() {
      this.isLoading = true;
      const endpoint = this.isEditMode
        ? `/districts/${this.itemId}`
        : "/districts";
      const method = this.isEditMode ? "put" : "post";
      let body = {
        name: this.name,
        division_id: this.divisionID.id,
      };
      try {
        const response = await http[method](endpoint, body);

        this.$toast.success(response.data.message);
        this.$handleModal("add_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        this.errors = error.response.data.errors;
      } finally {
        this.isLoading = false;
      }
    },
    async deleteItem() {
      this.isLoading = true;
      const endpoint = `/districts/${this.itemId}`;
      const method = "delete";
      try {
        const response = await http[method](endpoint);
        this.$toast.success(response.data.message);
        this.$handleModal("delete_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
